import { useContext } from 'react'
import { Dialog } from '@mui/material'

import AuthContext from 'context/AuthContext'
import { formatNumber } from 'utils/utils'
import ActiveOfferAvatar from 'pages/GamesList/components/redesign/ActiveOfferAvatar'
import { getCurrentTask, getOfferProgress } from 'pages/GamesList/components/redesign/offerRewards'

/** Asks before archiving an offer in progress, reminding the user how far through it they are. */
const ArchiveDialog = ({ game, open, onKeep, onArchive, onExited }) => {
  const { user } = useContext(AuthContext)
  const { gameDetails, activatedOffer } = game

  const offerProgress = getOfferProgress(activatedOffer)
  const currentTask = getCurrentTask(activatedOffer, {
    hasParsingEnabled: user?.hasParsingEnabled,
  })

  return (
    <Dialog
      open={open}
      onClose={onKeep}
      TransitionProps={{ onExited }}
      aria-labelledby="game-library-archive-title"
      PaperProps={{
        className: 'gameLibraryArchiveDialog',
        sx: { width: 340, maxWidth: 'calc(100% - 32px)', margin: 0, borderRadius: '20px' },
      }}
    >
      <ActiveOfferAvatar offer={{ iconUrl: gameDetails.icon_url, activatedOffer }} size={58} />
      <h2 id="game-library-archive-title" className="gameLibraryArchiveTitle">
        Archive <span>{gameDetails.name}?</span>
      </h2>
      <div className="gameLibraryArchiveProgress">
        {offerProgress && (
          <div className="gameLibraryArchiveProgressTop">
            <span>You’re {Math.round(offerProgress.progress * 100)}% through</span>
            {currentTask?.piggyBanks > 0 && (
              <span className="gameLibraryArchiveNext">
                <span className="gamesRedesignRewardPillValue">
                  {formatNumber(currentTask.piggyBanks)}
                </span>
                <img src="/images/pig.png" alt="piggy banks" width={18} height={18} />
              </span>
            )}
          </div>
        )}
        <p>Your progress is kept. Play it again anytime and it comes back to Continue.</p>
      </div>
      <button type="button" className="gameLibraryArchiveKeep" onClick={onKeep}>
        Keep earning!
      </button>
      <button type="button" className="gameLibraryArchiveConfirm" onClick={onArchive}>
        Archive anyways
      </button>
    </Dialog>
  )
}

export default ArchiveDialog
